import { useGetBuildings } from "../services/buildingService";
import { usePaginatedResource } from "../../../shared/hooks/usePaginatedResource";

export const useBuildingsResource = () => {
  const {
    page,
    pageSize,
    filters,
    debouncedFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
  } = usePaginatedResource({
    initialFilters: {
      name: "",
      city_id: undefined as number | undefined,
    },
  });

  const {
    data: buildings,
    isLoading,
    isError,
    refetch,
  } = useGetBuildings({
    page,
    page_size: pageSize,
    name: debouncedFilters.name || undefined,
    city_id: debouncedFilters.city_id || undefined,
  });

  return {
    data: buildings,
    isLoading,
    isError,
    page,
    pageSize,
    filters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
    refetch,
  };
};

